<template>
  <nav class="navbar navbar-expand-lg navbar-light fixed-top" id="mainNav">
    <div class="container">
      <a class="navbar-brand js-scroll-trigger" target="_blank" href="https://www.facebook.com/GrupoCosmic/">
        <i class="fab fa-facebook-square"></i>
      </a>
      <a class="navbar-brand js-scroll-trigger" target="_blank" href="https://www.instagram.com/grupo_cosmic_mexico/?hl=es">
        <i class="fab fa-instagram"></i>
      </a>
      <a class="navbar-brand js-scroll-trigger" target="_blank" href="https://www.linkedin.com/company/grupo-cosmic?originalSubdomain=mx">
        <i class="fab fa-linkedin-square"></i>
      </a>
      <button class="navbar-toggler navbar-toggler-right" type="button" data-toggle="collapse" data-target="#navbarResponsive" aria-controls="navbarResponsive" aria-expanded="false" aria-label="Toggle navigation">
        <span class="navbar-toggler-icon"></span>
      </button>
      <div class="collapse navbar-collapse" id="navbarResponsive">
        <ul class="navbar-nav nav-fill w-100">
          <li class="nav-item">
            <a class="nav-link js-scroll-trigger" href="#page-top">Home</a>
          </li>
          <li class="nav-item">
            <a class="nav-link js-scroll-trigger" href="#about">¿Quiénes Somos?</a>
          </li>
          <li class="nav-item">
            <a class="nav-link js-scroll-trigger" href="#services">¿Qué Hacemos?</a>
          </li>
          <li class="nav-item">
            <a class="nav-link js-scroll-trigger" href="#coverage">
              Cobertura
            </a>
          </li>
          <li class="nav-item">
            <a class="nav-link js-scroll-trigger" href="#clients">
              Clientes
            </a>
          </li>
          <li class="nav-item">
            <a class="nav-link js-scroll-trigger" href="#contact">
              Bolsa de trabajo
            </a>
          </li>
          <li class="nav-item">
            <a class="nav-link js-scroll-trigger" href="#cfdi">
              CFDI
            </a>
          </li>
        </ul>
      </div>
    </div>
  </nav>
</template>

<script>
export default {
  name: 'MainMenu',
  data() {
    return {
    }
  },
  created() {
  },
  methods:{
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/menu/MainMenu.vue